import Button from "component/design-system/buttons/Button";
import PAImage from "component/design-system/images/PAImage";
import PAText from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import LazyBackgroundImage from "modules/lazy-background-image/LazyBackgroundImage";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useSelector } from "react-redux";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import isFeatureEnabled from "util/helper/isFeatureEnabled";
import styles from "./avatarClub.module.scss";

function AvatarClub() {
  const { t } = useTranslation("home");

  const auth = useSelector((state: RootState) => state.authenticationState);
  const { expConfigurations } = auth;
  const isLoyaltyEnabled = isFeatureEnabled(expConfigurations, "loyalty");

  if (!isLoyaltyEnabled) {
    return null;
  }

  return (
    <div className={styles.avatar_club}>
      <div className={styles.avatar_club_text_container}>
        <PAImage
          src={getRelativeImagePath("/cms/pubicImages/images/rewards-home-1.webp")}
          alt="Avatar Club Coin"
          width={120}
          height={120}
          className={styles.avatar_club_coin}
        />
        <PAText bold className={styles.avatar_club_text}>
          {t("AVATAR CLUB")}
        </PAText>
        <PAText bold className={styles.avatar_club_text}>
          {t("EARN AT LEAST 1 POINT PER $1")}
        </PAText>
        <PAText className={styles.avatar_club_text}>
          {t("And even more during our frequent Point Multiplier Events and Category Promotions.")}
        </PAText>
        <Button variant="brand-outline" bold size="lg" asChild>
          <Link href="/rewards">{t("Learn more")}</Link>
        </Button>
      </div>
      <div className={styles.avatar_club_image_container}>
        <LazyBackgroundImage
          src={getRelativeImagePath("/cms/pubicImages/images/rewards-home-2.webp")}
          className={styles.avatar_club_image}
        />
      </div>
    </div>
  );
}

export default AvatarClub;
